import { currentAppState } from '../utils/mobile';

const appMobile = (state = {
    appState: currentAppState(),
    isConnected: true,
    currentProjectId: null,
    dashboardSubteam: null
}, action) => {
    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                appState: currentAppState(),
                isConnected: true,
                currentProjectId: null,
                dashboardSubteam: null
            };

        case 'APP_STATE_CHANGE_REQUESTED':
            return Object.assign({}, state, {
                appState: action.payload.appState
            });

        case 'APP_IS_CONNECTED_CHANGE_REQUESTED':
            return Object.assign({}, state, {
                isConnected: action.payload.isConnected
            });

        case 'SET_REDIRECT_ROUTE_REQUESTED':
            return Object.assign({}, state, {
                redirectRoute: action.payload.route
            });

        case 'SET_CURRENT_PROJECT':
            return Object.assign({}, state, {
                currentProjectId: action.payload.projectId
            });

        case 'SET_DASHBOARD_SUBTEAM':
            return Object.assign({}, state, {
                dashboardSubteam: action.payload.subteamId
            });

        default:
            return state;
    }
};

export default appMobile;
